import stateMap from '../addressFields/data/USStateMap';


export function getFilteredStatesFromExcludedBillingStates(excludedBillingStates) {
    const excludedBillingStatesSanitizedArray = excludedBillingStates.replace(/ /g, '').split(',');
    return Object.keys(stateMap).filter(state => !excludedBillingStatesSanitizedArray.includes(state));
}
